<template>
  <div class="not_data_box">
    <img
      v-if="!$slots.img"
      src="./notDataImg.png"
      class="not_data_img"
      alt=""
    />
    <slot name="img"></slot>
    <div v-if="!$slots.msg" class="not_msg">暂无数据</div>
    <slot name="msg" class="not_msg"></slot>
    <slot name="btns"></slot>
    <slot></slot>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    }
  }
</script>
<style lang="less" scoped>
  .not_data_box {
    width: 100%;
    height: 100%;
    display: flex;
    flex: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .not_data_img {
      width:300px;
      height: 300px;
      margin-bottom: 30px;
    }
    .not_msg {
      color: #333333;
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
</style>
